import { Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Comments } from '@app/models/form-comment';


export interface ChatDialogData {
  complaintId: number;
  editable: boolean;
  comments: Comments[];
  isDialog: boolean;
}

@Component({
  selector: 'app-chat-dialog',
  templateUrl: './chat-dialog.component.html',
  styleUrls: ['./chat-dialog.component.scss']
})
export class ChatDialogComponent implements OnInit {
  
  public loading: boolean;
  public userName: string;

  @Input() complaintId: number;
  @Input() editable: boolean;
  @Input() comments: Comments[];
  isDialog: boolean = false;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: ChatDialogData,
    @Optional()
    private dialogRef: MatDialogRef<ChatDialogComponent>,
  ) {
    // this.userName = authService.currentUser.userName;
  }

  ngOnInit(): void {

    this.complaintId = this.complaintId ? this.complaintId : this.data.complaintId;
    this.editable = this.editable ? this.editable : this.data ? this.data.editable : false;
    this.comments = this.comments ? this.comments : this.data ? this.data.comments : [];
    this.isDialog = this.data?.isDialog ?? false;

    if (this.dialogRef) {
      this.dialogRef.beforeClosed().subscribe(value => this.dialogRef.close(this.comments));
    }

  }

  addComment(comment: string) {

    if (!this.complaintId && comment) {
      let newComment: Comments = {
        id: 0,
        comment,
        createdBy: null,
        createdDate: new Date()
      }
      this.comments.push(newComment);
    }
    
  }

  deleteMessage(index: number): void {
    this.comments.splice(index, 1);
  }
  
  onDismiss() {
    this.dialogRef.close(this.comments);
  }

}
